<template>
  <div class="container">
    <div class="block">
      <div class="content-inner-wrapper">
        <img src="../../images/mobile/noAny.svg" />
        <p>购买服务器和好朋友一起开启游戏吧～</p>
        <van-button
          @click="$router.push({ name: 'cloudServerBuy' })"
          type="primary"
          >购买服务器</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style src="../../style/common-m.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
img {
  display: block;
  width: 480px;
  height: 350px;
  margin: 260px auto 32px;
}
p {
  width: 400px;
  height: 34px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666;
  line-height: 34px;
  text-align: center;
  margin: 0 auto 108px;
  text-align: center;
}
.van-button {
  display: block;
  width: 526px;
  height: 84px;
  background: #fd9b21ff;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3d3c3c;
  line-height: 40px;
  border-radius: 16px;
  margin: 0 auto 288px;
  border-color: #fff;
}
.container .block .title-wrap {
  border-bottom: none;
}
</style>
